import React from 'react';
import {
  InputRightAddon,
  InputGroup,
  NumberInput,
  NumberInputField,
} from '@chakra-ui/react';

import {
  formatDecimalAsPercentage,
  parsePercentageAsDecimal,
} from '../lib/numberUtils';
import PercentIcon from './PercentIcon';

export default function PercentageInput({
  percentageValue,
  setPercentageValue,
}: {
  percentageValue: number;
  setPercentageValue: (val: number) => void;
}) {
  return (
    <InputGroup>
      <NumberInput
        onChange={(valueString, valueAsNumber) =>
          setPercentageValue(parsePercentageAsDecimal(valueAsNumber))
        }
        value={formatDecimalAsPercentage(percentageValue)}
        max={1.0}
        min={0}
        // we want the error message to pop up, change the value if its invalid
        clampValueOnBlur={false}
        keepWithinRange={false}
      >
        <NumberInputField />
      </NumberInput>
      <InputRightAddon pointerEvents="none">
        <PercentIcon />
      </InputRightAddon>
    </InputGroup>
  );
}
